import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import useAuth from "../hooks/useAuth";
import useRefreshToken from "../hooks/useRefreshToken";

const RequireAuth = () => {
    const { auth } = useAuth();
    const refresh = useRefreshToken();

    useEffect(() => {
        const fetch = async () => {
            if (!auth?.accessToken) {
                await refresh();
            }
        }
        fetch();
    }, [auth?.accessToken, refresh]);

    const location = useLocation();
    
    if (auth === undefined) {
        return <div>Loading...</div>
    }

    return (
        auth?.accessToken ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;